var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 16.0888C30.5 8.03143 24.0084 1.5 16.0018 1.5C7.99156 1.50181 1.5 8.03144 1.5 16.0906C1.5 23.3705 6.80271 29.4054 13.7328 30.5V20.306H10.0539V16.0906H13.7365V12.8738C13.7365 9.21847 15.9021 7.1996 19.2132 7.1996C20.8007 7.1996 22.4589 7.48413 22.4589 7.48413V11.0724H20.6304C18.8308 11.0724 18.269 12.1979 18.269 13.3523V16.0888H22.2886L21.647 20.3042H18.2672V30.4982C25.1973 29.4036 30.5 23.3687 30.5 16.0888Z",
    fill: "#1385C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgFacebook);
export default __webpack_public_path__ + "static/media/img_facebook.14864a312e074449ae8147a4c8eab351.svg";
export { ForwardRef as ReactComponent };